module.exports = __webpack_public_path__ + "assets/img/1231587028414_.pic_hd.8a0c2f5e.jpg";